import { z } from 'zod';

export const PRODUCT_TYPES = ['app', 'physical', 'service'] as const;
export const ProductTypeSchema = z.enum(PRODUCT_TYPES);
export type ProductType = z.infer<typeof ProductTypeSchema>;

export const BrandDNASchema = z.object({
  productType: ProductTypeSchema,
  primaryColor: z.string(),
  accentColor: z.string(),
  background: z.string(),
  typography: z.string(),
  photographyStyle: z.string(),
  photographyMood: z.string(),
  productDescription: z.string(),
  usp: z.string(),
  audience: z.string(),
  headlineTone: z.string(),
  promptModifier: z.string().max(800).optional(),
});
export type BrandDNA = z.infer<typeof BrandDNASchema>;

export const BrandSchema = z.object({
  id: z.string(),
  name: z.string().min(1),
  url: z.string().url().optional(),
  dna: BrandDNASchema,
  createdAt: z.number(),
  updatedAt: z.number(),
});
export type Brand = z.infer<typeof BrandSchema>;
